import { CancelError } from "./CancelError";

// A request was cancelled because the connection was down when it timed out.
export class DisconnectedError extends CancelError {
  constructor() {
    super("No Network connection");
  }
}
